import React, { useState, useEffect } from 'react';
import Options from '../../../../../../controls/options';
import './index.scss';

const Buttons = ({ id, disabled, options, groupOptionsByCount, onSelect }) => {
    const [numberOfOptions, setNumberOfOptions] = useState(groupOptionsByCount);

    const groupingEnabled = groupOptionsByCount && numberOfOptions < options.length;
    if (groupingEnabled) {
        options = options.slice(0, numberOfOptions);
    }

    const showMoreOptions = () => {
        if (disabled) {
            return;
        }
        setNumberOfOptions(numberOfOptions + groupOptionsByCount);
    };

    useEffect(() => {
        const options = document.querySelectorAll(`#buttons-${id} li`);
        const lastOption = options[options.length - 1];
        lastOption.scrollIntoView({ behavior: 'smooth' });
    }, [numberOfOptions]);

    return (
        <div className={`message-buttons ${disabled ? 'disabled' : ''}`} id={`buttons-${id}`}>
            <Options
                disabled={disabled}
                options={options.map((o) => {
                    return {
                        id: o.id,
                        name: o.text
                    };
                })}
                onClick={(id) => onSelect(id)}
            />
            {groupingEnabled && (
                <div className="link">
                    <a onClick={showMoreOptions}>Więcej...</a>
                </div>
            )}
        </div>
    );
};

export default Buttons;
